import React, { useEffect, useState, useRef } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
// import Quill from 'quill';
import '../Quill/Quill.css';
//import { SizeStyle } from 'parchment';
import { Button, Form } from 'react-bootstrap';
import TextArea from 'antd/lib/input/TextArea';
import { Modal, Tooltip } from 'antd';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';


// Define custom font sizes using Quill's Parchment API
//const Size = Quill.import('formats/size');
//Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '24px', '32px', '48px'];
//Quill.register(Size, true);


const Size = Quill.import('attributors/style/size');
const BlockEmbed = Quill.import('blots/block/embed');
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '24px', '32px', '42px'];
Quill.register(Size, true);

class ContentBlock extends BlockEmbed {
    static blotName = 'contentBlock';
    static tagName = 'div';

    static create(value) {
        const node = super.create();
        node.classList.add('custom-blot-content', 'w-100');
        node.setAttribute('id', `custom-blot-content`);
        node.setAttribute('contenteditable', 'false');
        node.style.cursor = 'not-allowed';
        node.title = 'Please edit the HTML content below';
        node.innerHTML = value;
        return node;
    }

    static value(node) {
        return node.innerHTML;
    }
    static isContentBlock(node) {
        return node && node.classList && node.classList.contains('custom-blot-content');
    }
}
if (!Quill.imports['formats/contentBlock']) {
    Quill.register(ContentBlock);
}

const ReactQuillEditor = ({ value, onChangeValue }) => {
    const [editorValue, setEditorValue] = useState('');
    const quillRef = useRef(null);
    const { confirm } = Modal;

    const [htmlvalue, setHtmlValue] = useState('');
    const [textarea, setTextArea] = useState(false);
    const [previewHtml, setPreviewHtml] = useState(false);

    const [inSecureContent, setInsecureContent] = useState(false)

    useEffect(() => {
        const htmlButton = document.getElementsByClassName('ql-HTML')[0];
        if (htmlButton) {
            htmlButton.innerHTML = '<i class="fas fa-code"></i>';
            htmlButton.title = 'Insert HTML block';
            htmlButton.onclick = () => {
                setTextArea((prev) => !prev);
            };
        }
    }, []);

    useEffect(() => {
        // Parse the editor value and extract custom-blot-content's inner HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(editorValue, 'text/html');
        const customBlot = doc.querySelector('.custom-blot-content');
        if (customBlot) {
            setHtmlValue(customBlot.innerHTML);
        }
    }, [editorValue]);

    useEffect(() => {
        setEditorValue(value);

        // After setting content, move cursor to the end
        const editor = quillRef.current.getEditor();
        if (editor) {
            const length = editor.getLength();
            editor.setSelection(length - 1, 0, 'silent'); // Set cursor at end
        }
    }, [value]);

    const handleChange = (content) => {
        setEditorValue(content);
        if (onChangeValue) {
            onChangeValue(content); // Send content back to the parent component
        }
    };

    useEffect(() => {
        const quill = quillRef.current.getEditor();
        if (!quill) return;

        const toolbar = quill.getModule('toolbar');
        if (!toolbar) return;

        // Override the default 'clean' handler
        toolbar.addHandler('clean', () => {
            cleanEditor();
        });
    }, []);

    const cleanEditor = () => {
        const editor = quillRef.current.getEditor();
        if (!editor) return;

        const length = editor.getLength();

        // Remove formatting
        editor.removeFormat(0, length);

        // Place cursor at end (or wherever you'd like)
        editor.setSelection(length - 1, 0, 'silent');

        // Force update the format to default size (14px)
        editor.format('size', '14px');
    };
    const togglepreview = () => {
        setPreviewHtml(prev => !prev)
        setInsecureContent(/(?:\s\w+\s*=\s*["'])http:\/\//i.test(htmlvalue))
    }

    const insertHtmlAtCursor = async (e) => {
        e.preventDefault();
        const quill = quillRef.current.getEditor();

        const editorContents = quill.getContents();
        let foundIndex = null;
        let currentBlockValue = '';

        editorContents.ops.forEach((op, idx) => {
            if (op.insert && op.insert.contentBlock !== undefined) {
                foundIndex = idx;
                currentBlockValue = op.insert.contentBlock;
            }
        });
        const hasInsecureHttpLinks = /(?:\s\w+\s*=\s*["'])http:\/\//i.test(htmlvalue);

        // Prevent update if htmlvalue is empty or unchanged
        if (!htmlvalue.trim() || htmlvalue === currentBlockValue) {
            return;
        }

        // Await user's confirmation if there are http links
        if (hasInsecureHttpLinks) {
            const confirmed = await new Promise((resolve) => {
                confirm({
                    icon: null,
                    title: 'Insecure Content Detected',
                    content: (
                        <div>
                            <p>
                                This HTML contains <code>http://</code> links, which may cause the page to be marked as <strong>"Not Secure"</strong> in your browser.
                            </p>
                            <p>
                                Do you want to proceed? You can verify this in the browser tab after importing or previewing the content.
                            </p>
                        </div>
                    ),
                    okText: 'Proceed',
                    okType: 'danger',
                    cancelText: 'Cancel',
                    className: 'insecure-model-quill-html',
                    onOk() {
                        resolve(true);
                    },
                    onCancel() {
                        resolve(false);
                    },
                });

            });

            if (!confirmed) {
                return;
            }
        }

        if (foundIndex !== null) {
            let index = 0;
            for (let i = 0; i < foundIndex; i++) {
                index += typeof editorContents.ops[i].insert === 'string'
                    ? editorContents.ops[i].insert.length
                    : 1;
            }
            quill.deleteText(index, 1, 'user');
            quill.insertEmbed(index, 'contentBlock', htmlvalue, 'user');
            quill.setSelection(index + 1, 0);
        } else {
            const range = quill.getSelection(true);
            const insertIndex = range ? range.index : quill.getLength();
            quill.insertEmbed(insertIndex, 'contentBlock', htmlvalue, 'user');
            quill.setSelection(insertIndex + 1, 0);
        }
    };

    // Inside useEffect
    useEffect(() => {
        cleanEditor(); // Run it only once on mount
    }, []);

    // Define custom fonts using Quill's Parchment API
    const Font = Quill.import('formats/font');
    Font.whitelist = [
        'arial',
        'georgia',
        'impact',
        'verdana',
        'calibri',
        'helvetica',
        'garamond',
        'tahoma'
    ];
    Quill.register(Font, true);


    // Toolbar configuration with custom font sizes
    const modules = {
        toolbar: {
            container: [
                // Custom toolbar with numeric font sizes              
                ['bold', 'italic', 'underline'], // Formatting
                [{ list: 'ordered' }, { list: 'bullet' }], // Lists

                [
                    {
                        size: [
                            '10px',
                            '12px',
                            '14px',
                            '16px',
                            '18px',
                            '24px',
                            '32px',
                            '48px',
                        ], // Font sizes
                    },
                ],
                [{ color: [] }, { background: [] }], // Text color and background
                [{ font: Font.whitelist }],
                ['link', 'image'], // Links, images, videos
                ['clean'], // Remove formatting
                ['HTML'],

            ],
        },
    };

    const formats = [
        'header',
        'bold',
        'italic',
        'underline',
        'strike',
        'list',
        'bullet',
        'indent',
        'direction',
        'size',
        'color',
        'background',
        'font',
        'align',
        'link',
        'image',
        'video',
        'contentBlock'
    ];

    return (
        <div>
            <ReactQuill
                ref={quillRef}
                theme="snow"
                value={editorValue}
                onChange={handleChange}
                modules={modules}
                formats={formats}
            />
            {textarea && (
                <Form className='mt-2 html-editor' onSubmit={insertHtmlAtCursor}>
                    <TextArea
                        defaultValue={htmlvalue}
                        placeholder='Write your HTML here'
                        onChange={(e) => setHtmlValue(e.target.value)}
                    />
                    <div className="d-flex gap-2">
                        <Button title='Insert your custom HTML into the editor' type='submit'>Update HTML</Button>
                        <Button title='Preview how your HTML will look on a webpage' type='button' onClick={togglepreview}>Preview</Button>
                    </div>
                </Form>
            )}

            {previewHtml &&
                <div style={{ maxHeight: '400px', boxShadow: (/(?:\s\w+\s*=\s*["'])http:\/\//i.test(htmlvalue)) ? '0 0 20px rgba(255, 77, 79, 0.6)' : 'none' }} className={`bg-light mt-3 border overflow-auto rounded-sm border-b-1 ${(/(?:\s\w+\s*=\s*["'])http:\/\//i.test(htmlvalue)) ? 'border-danger' : ''}`}>
                    <div className="preview-heading d-flex p-3 justify-content-between align-items-center position-sticky top-0 bg-light">
                        <h5 className='mb-0'>🔍 Live HTML Preview</h5>
                        {
                            (/(?:\s\w+\s*=\s*["'])http:\/\//i.test(htmlvalue)) &&
                            <Tooltip title="Insecure Content: Detected 'http://' links in the HTML content, which will be rendered below. This may cause the page to be marked as Not Secure. Consider using 'https://' instead.">
                                <ErrorOutlineIcon style={{ color: '#ff4d4f', cursor: 'pointer' }} />
                            </Tooltip>
                        }
                    </div>
                    <div className={`${htmlvalue.trim() === '' ? '' : 'p-2'}`} dangerouslySetInnerHTML={{ __html: htmlvalue }} />
                </div>}
        </div>
    );
};

export default ReactQuillEditor;

